<template>
  <div class="calculator bmi">
    <h1 class="page-header">Body Fat Calculator</h1>
    <div>
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="5">
          <base-radio
            id="gender-selector"
            :value="gender"
            :options="[
              { label: 'male', desc: 'Male' },
              { label: 'female', desc: 'Female' },
            ]"
            @set-new-value="gender = $event.newValue"
          >
          </base-radio>
        </el-col>
        <el-col :span="5">
          <base-radio
            id="metric-imperial-selector"
            :value="units"
            :options="[
              { label: 'metric', desc: 'Metric' },
              { label: 'imperial', desc: 'Imperial' },
            ]"
            @set-new-value="units = $event.newValue"
          >
          </base-radio>
        </el-col>
      </el-row>
      <br />
      <weight-fieldset
        :units="units"
        :weight="weight"
        @change-weight="weight = $event.weight"
      >
      </weight-fieldset>
      <br />
      <height-fieldset
        :units="units"
        :height="height"
        @change-height="height = $event.height"
      >
      </height-fieldset>
      <br />
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="5">
          <size-cm-inches
            name="neck"
            :units="units"
            :size="neck"
            @change-size="neck = $event.size"
          >
          </size-cm-inches>
        </el-col>
        <el-col :span="5">
          <size-cm-inches
            name="waist"
            :units="units"
            :size="waist"
            @change-size="waist = $event.size"
          >
          </size-cm-inches>
        </el-col>
        <el-col v-if="gender === 'female'" :span="5">
          <size-cm-inches
            name="hip"
            :units="units"
            :size="hip"
            @change-size="hip = $event.size"
          >
          </size-cm-inches>
        </el-col>
      </el-row>
    </div>
    <br />
    <br />
    <div>
      <el-button type="primary" @click="setBodyFat" round>
        Calculate Body Fat
      </el-button>
    </div>
    <br />
    <br />
    <div v-if="bodyFat > -1">
      <el-card class="box-card">
        <div class="text result">Your Body Fat is {{ bodyFat }}%</div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { cmToInches } from "@/utils/conversions.js"
import BaseRadio from "@/components/BaseRadio.vue"
import WeightFieldset from "@/components/health/WeightFieldset.vue"
import HeightFieldset from "@/components/health/HeightFieldset.vue"
import SizeCmInches from "@/components/health/SizeCmInches.vue"

export default {
  name: "BodyFat",
  components: {
    BaseRadio,
    WeightFieldset,
    HeightFieldset,
    SizeCmInches,
  },
  data() {
    return {
      gender: "male",
      units: "metric",
      bodyFat: -1,
      weight: 80,
      height: 170,
      neck: 42,
      waist: 85,
      hip: 92,
    }
  },
  methods: {
    setBodyFat() {
      // This uses the US military formula
      // https://www.thebalancecareers.com/united-states-military-body-fat-standards-3356944#:~:text=The%20Department%20of%20Defense%20formula,log10(height)%20%2D%2078.387.

      // Note calc uses inches - round down to nearest half inch
      var bf
      if (this.gender == "male") {
        bf =
          86.01 * Math.log10(cmToInches(this.waist) - cmToInches(this.neck)) -
          70.041 * Math.log10(cmToInches(this.height)) +
          36.76
        this.bodyFat = Math.round(bf * 10) / 10
      } else {
        bf =
          163.205 *
            Math.log10(
              cmToInches(this.waist) +
                cmToInches(this.hip) -
                cmToInches(this.neck)
            ) -
          97.684 * Math.log10(cmToInches(this.height)) -
          78.387
      }
      this.bodyFat = Math.round(bf * 10) / 10
    },
  },
}
</script>

<style scoped>
</style>